import justPoly from "../../assets/buttons/just-poly.svg";
import { Link } from "react-router-dom";

type DefineButtonProps = {
	label: string;
	href?: string;
	target?: string;
	backgroundUrl?: string;
	onClick?: () => void;
	navigateTo?: string;
};

export const defineButton = ({
	label, 
	href, 
	target, 
	backgroundUrl, 
	onClick,
	navigateTo,
}: DefineButtonProps) => {
	return {
		label,
		href,
		target,
		backgroundUrl,
		onClick,
		navigateTo,
	} as DefineButtonProps;
}

export const getUniqueIdentifier = (props: DefineButtonProps) => {
	return [
		props.label,
		props.href,
		props.target,
		props.backgroundUrl,
		props.navigateTo,
	].filter(Boolean).join("-");
}

export const DynamicBigButton = ({ label, href, onClick, backgroundUrl, target, navigateTo }: DefineButtonProps) => {

	const content = backgroundUrl ? <img src={backgroundUrl} alt={label} className="w-[110%]" /> : <>
		<img
			src={justPoly}
			alt={label}
			className="w-full"
		/>
		<div className="absolute inset-0 flex items-center justify-center">
			<span className="max-w-[66%] text-center font-bold uppercase">
				{label}
			</span>
		</div>
	</>;

	const wrappedContent = <div className="relative w-[29vw] hover:scale-110 transition-all hover:brightness-110">
		{content}
	</div>

	if (href) {
		return <a href={href} target={target} onClick={onClick}>{wrappedContent}</a>
	}

	if (navigateTo) {
		return <Link to={navigateTo} target={target} onClick={onClick}>{wrappedContent}</Link>
	}

	return <button onClick={onClick}>{wrappedContent}</button>
};